// Centralised tunables. Keep client + server in lockstep via this file.
// (functions/src/model.ts mirrors the server-side subset.)

// Models.
export const MODEL_SONNET = 'claude-sonnet-4-6' as const;
export const MODEL_HAIKU = 'claude-haiku-4-5-20251001' as const;

// Message limits.
export const MAX_MESSAGE_CHARS = 500;
export const MAX_CHAT_HISTORY_FOR_PROMPT = 12;
export const MAX_CHAT_HISTORY_DISPLAYED = 50;

// Per-uid rate limits. A player often commits 3 bots per scene in a burst, so
// keep the per-minute ceiling generous; the $25/day breaker is the real backstop.
export const RATE_LIMIT_MSG_PER_MIN = 15;
export const RATE_LIMIT_MSG_PER_DAY = 200;

// Global circuit breaker.
export const BREAKER_DAILY_USD_HARD = 25;
export const BREAKER_ALERT_USD = 10;
export const BREAKER_CALLS_PER_MIN = 120;
export const EST_USD_PER_SONNET_TURN = 0.01;

// Player name.
export const MAX_PLAYER_NAME_CHARS = 24;
export const MIN_PLAYER_NAME_CHARS = 2;
export const PLAYER_NAME_BLOCKLIST: readonly string[] = [
  'system', 'admin', 'administrator', 'moderator', 'mod',
  'claude', 'anthropic', 'assistant', 'user',
  'narrator', 'god', 'goddess', 'devil', 'satan', 'jesus', 'allah',
  'spirit', 'spirits', 'bot', 'bots', 'npc', 'spirits-game', 'null', 'undefined',
];

export const PLAYER_NAME_AUTO_ADJECTIVES = [
  'Quiet', 'Hushed', 'Drifting', 'Pale', 'Soft', 'Gentle', 'Distant', 'Wandering',
  'Faint', 'Hollow', 'Warm', 'Silver', 'Amber', 'Misty', 'Tender', 'Restless',
  'Solemn', 'Bright', 'Ember', 'Cold',
] as const;
export const PLAYER_NAME_AUTO_NOUNS = [
  'Wisp', 'Echo', 'Whisper', 'Shade', 'Breath', 'Hush', 'Glimmer', 'Drift',
  'Veil', 'Mote', 'Spark', 'Mist', 'Halo', 'Wraith', 'Thread', 'Lantern',
  'Tide', 'Vow', 'Tear', 'Ripple',
] as const;
